<template>
  <button
    class="app-button"
    :class="[variant, { pulse: isPulsing, disabled: isDisabled }]"
    :disabled="isDisabled"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "outline", "icon"].includes(value),
    },
    isPulsing: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.app-button {
  background-color: var(--accent-color);
  color: var(--bg-color);
  border: none;
  padding: 15px 30px;
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  display: block;
  width: 100%;
  margin: var(--spacing-lg) 0;
  text-align: center;
}

.app-button:hover:not(.disabled) {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.app-button:active:not(.disabled) {
  transform: translateY(1px);
}

.app-button.outline {
  background-color: transparent;
  color: var(--accent-color);
  border: 2px solid var(--accent-color);
}

.app-button.icon {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-sm);
}

.app-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.app-button.pulse {
  animation: pulse 1.5s infinite;
}
</style>
